module.exports = __webpack_public_path__ + "static/media/colchagua.b8069043.png";